import React from 'react';
import ReactDOM from 'react-dom';

import './Portals.scss';

interface PortalProps {
	children?: React.ReactNode;
	className?: string;
	el?: string;
}

const TopMostPortal: React.FC<PortalProps> = ({ children = undefined, className = 'top-most-portal', el = 'div' }) => {
	const [container] = React.useState<HTMLElement>(() => {
		// This will be executed only on the initial render
		// https://reactjs.org/docs/hooks-reference.html#lazy-initial-state
		return document.createElement(el);
	});

	React.useEffect(() => {
		className && container.classList.add(className)
		document.body.appendChild(container)
		return () => {
			document.body.removeChild(container)
		}
	}, [])

	return ReactDOM.createPortal(children, container)
}


export default TopMostPortal;